import Tasks from 'APP/Tasks';
import { messageModel } from 'APP/model/model';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { ArticlePayload } from 'STORE/Messages/Message/Payload/ArticlePayload/ArticlePayload';

export async function updateDraftArticle(
  groupId: string,
  draftId: string,
  payload: ArticlePayload
): Promise<void> {
  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return;
  }

  const canEdit = Tasks.messaging.canSendMessage({
    groupId,
    isCheckSlowMode: false,
    isNewMessage: false,
    payload,
  });

  if (!canEdit.result) {
    canEdit.error && Tasks.app.showToast(canEdit.error);
    return;
  }

  try {
    const draftData = await messageModel.updateDraft({
      groupId,
      draftId,
      payload: payload.toJSON(),
    });

    const draftMessage = new ChatMessage(draftData, group.messagesStore);
    group.draftsStore.updateDraft(draftMessage);
  } catch {
    //
  }
}
